import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import type {
	UpdateClientContactMutation,
	UpdateClientContactMutation$data as UpdateClientContactMutationResponse,
	UpdateClientContactMutation$variables,
} from './__generated__/UpdateClientContactMutation.graphql';

type UpdateClientContactInput = UpdateClientContactMutation$variables['input'];

const mutation = graphql`
	mutation UpdateClientContactMutation($input: UpdateClientContactInput!) {
		updateClientContact(input: $input) {
			clientContact {
				id
				firstName
				lastName
				email
				jobTitle
				phone
				status
				isGuestUser
				client {
					id
					name
				}
				projects {
					edges {
						node {
							id
							name
						}
					}
				}
			}
		}
	}
`;

export type UpdateClientContactCommitInput = Omit<UpdateClientContactInput, 'csrfToken' | 'socketClientId'>;

function commit(
	environment: Environment,
	input: UpdateClientContactCommitInput,
	onSuccess?: (response: UpdateClientContactMutationResponse) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<UpdateClientContactMutation>(environment, {
		mutation,
		variables: {
			input: {
				...input,
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
			},
		},
		onCompleted: (response: UpdateClientContactMutationResponse) => {
			trackEvent('Client Contact', 'Updated');
			onSuccess?.(response);
		},
		onError,
	});
}

export default {commit};
